<template>
  <VListItem inactive class="white pa-2 mb-1">
    <VListItemAction class="mr-4 ml-2">
      <VCheckbox
        :input-value="isSelected"
        :true-value="isSelected"
        color="primary"
        hide-details
        @click.native="check"
      />
    </VListItemAction>
    <VListItemContent class="pr-4" @click="check">
      <div>
        {{ question.question }}
        <span v-if="question.recommended" class="text--disabled">{{ $t('recommended') }}</span>
        <span v-if="question.startTime === undefined" class="text--disabled">TXT</span>
      </div>
    </VListItemContent>
  </VListItem>
</template>

<script>
export default {
  name: 'VacancySelectQuestionRow',
  props: {
    question: {
      type: Object,
      required: true,
    },
    selected: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isSelected() {
      return this.selected.some((it) => it.id === this.question.id);
    },
  },
  methods: {
    check() {
      if (this.isSelected) {
        this.$emit('unselected', this.question);
      } else {
        this.$emit('selected', this.question);
      }
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  recommended: (Recommended)
</i18n>

<i18n locale="ru" lang="yaml">
  recommended: (Рекомендуется)
</i18n>
